import { Box, Button, Group, Stack, Text } from '@mantine/core';
import { IconCancel as CancelIcon, IconDeviceFloppy as SaveIcon } from '@tabler/icons-react';
import { FormEventHandler, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

export interface FormProps {
  onSubmit: FormEventHandler<HTMLFormElement>;
  onCancel?: () => void;
  title?: string;

  isSubmitting: boolean;
  isDisabled?: boolean;
}

export function Form(props: PropsWithChildren<FormProps>) {
  const { children, title, onSubmit, onCancel, isSubmitting, isDisabled } = props;
  const { t } = useTranslation();

  return (
    <Box
      component="form"
      onSubmit={onSubmit}
      p="xl"
      style={{ '--radius': '0.5rem', borderRadius: 'var(--radius)' }}
    >
      {title && (
        <Text
          size="lg"
          mb="sm"
          fw="500"
        >
          {title}
        </Text>
      )}
      <Stack>{children}</Stack>
      <Group
        mt="lg"
        justify="flex-end"
      >
        {onCancel && (
          <Button
            leftSection={<CancelIcon />}
            variant="outline"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            {t('button.cancel')}
          </Button>
        )}
        <Button
          leftSection={<SaveIcon />}
          type="submit"
          disabled={isSubmitting || isDisabled}
          loading={isSubmitting}
        >
          {t('button.save')}
        </Button>
      </Group>
    </Box>
  );
}
